import type { HeaderGroup } from '@tanstack/react-table';
import { TableCell, TableRow } from '@ksyos/design-system';
import { Filter } from './Filter';

type FilterRowProps<T> = {
    headerGroups: HeaderGroup<T>[];
};

export function FilterRow<T>({ headerGroups }: Readonly<FilterRowProps<T>>) {
    return headerGroups.map((headerGroup) => (
        <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
                <TableCell
                    key={header.id}
                    style={{ padding: 0 }}
                >
                    {header.column.getCanFilter() ? (
                        <div>
                            <Filter column={header.column} />
                        </div>
                    ) : null}
                </TableCell>
            ))}
        </TableRow>
    ));
}
